import CompanyLogoPanel from "./companyLogoPanel.container";

export default CompanyLogoPanel;
